/*
 * /transcripts/[slug] (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { TranscriptDetail } from "../../features/transcript/components/transcript-detail"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/transcripts/$transcriptId")({
	component: TranscriptDetailPage,
	loader: authPageLoader,
})

function TranscriptDetailPage() {
	const { transcriptId } = Route.useParams()
	const { user, token } = Route.useLoaderData()

	const { data: transcript, isLoading } =
		trpc.conversationTranscript.getByFilter.useQuery({
			where: { id: transcriptId },
		})

	if (isLoading) {
		return (
			<Page centerVertical={false}>
				<Container width={"xxxl"} padding={"lg"} gap={"sm"}>
					<Skeleton className={"h-8 w-64"} />
					<Divider />
					<div className={"flex flex-col lg:flex-row gap-4 w-full"}>
						<Skeleton className={"h-[400px] w-full lg:w-[420px]"} />
						<Skeleton className={"h-[400px] flex-1"} />
					</div>
				</Container>
			</Page>
		)
	}

	if (!transcript) {
		return (
			<Page centerVertical={true}>
				<Container width={"xl"} padding={"lg"}>
					<p className={"text-center text-muted-foreground"}>
						{"Transcript not found."}
					</p>
				</Container>
			</Page>
		)
	}

	return (
		<Page scrolling={false} centerVertical={false}>
			<Container
				width={"xxxl"}
				padding={"lg"}
				gap={"sm"}
				className={"flex flex-col h-full min-h-0"}
			>
				<PageHeader
					title={transcript.title}
					left={{
						href: "/transcripts",
						label: "Back",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"flex flex-1 min-h-0 pb-4"}>
					<TranscriptDetail transcript={transcript} user={user} token={token} />
				</div>
			</Container>
		</Page>
	)
}
